'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: ', ';\n  font-size: ', ';\n  letter-spacing: 1px;\n  font-weight: 300;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    flex: 1;\n  }\n'], ['\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: ', ';\n  font-size: ', ';\n  letter-spacing: 1px;\n  font-weight: 300;\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    flex: 1;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents2.default.label(_templateObject, function (props) {
  return props.disabled ? 'initial' : 'pointer';
}, (0, _rem2.default)('16px'));

Label.displayName = 'Label';

exports.default = Label;